import ErrorIcon from '@mui/icons-material/Error';
import { SvgIconProps } from '@mui/material';
import {
  BenefitActivationDTOBenefitEnum,
  BenefitDTOBenefitEnum,
  EmployeeDTOActiveBenefitsEnum,
  TenantDTO,
  TenantDTOActiveBenefitsEnum,
} from 'probonio-shared-ui/api';
import { getBenefitMetadata } from '../../extension/interface/benefit-metadata.extension.interface';
import { NonCashBenefit } from './nonCashBenefit/const';

export type AllBenefitsIncludingComing = EmployeeDTOActiveBenefitsEnum;

export const getBenefitIcon = (benefit: BenefitDTOBenefitEnum): React.ComponentType<SvgIconProps> => {
  return getBenefitMetadata(benefit)?.Icon ?? ErrorIcon;
};

export function isBenefitActive(tenant: TenantDTO | undefined, benefit: AllBenefitsIncludingComing): boolean | undefined {
  const isActiveNonCash =
    benefit === BenefitActivationDTOBenefitEnum.Coupons &&
    Object.values(NonCashBenefit).some(nonCashBenefit => tenant?.activeBenefits?.includes(nonCashBenefit));

  return isActiveNonCash || tenant?.activeBenefits?.includes(benefit as TenantDTOActiveBenefitsEnum);
}
